import React, {Component} from 'react';
import {app} from "app/app";
import 'assets/sass/dashboard/layout/Footer.scss';

export class Footer extends Component {
    render() {
        return (
            <footer className="dashboard-footer">
                <p>{new Date().getFullYear()} © {app.productName()}. Todos los derechos reservados</p>
            </footer>
        );
    }
}

